export default "__VITE_ASSET__BsgdbtGo__"